import { render, staticRenderFns } from "./ProfileTransparency.vue?vue&type=template&id=db267fe0&"
import script from "./ProfileTransparency.vue?vue&type=script&lang=js&"
export * from "./ProfileTransparency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports